import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-concept"]
const _hoisted_2 = { class: "Paper__container" }
const _hoisted_3 = { class: "Paper__header" }
const _hoisted_4 = { class: "irl" }
const _hoisted_5 = { class: "Paper__addresses" }
const _hoisted_6 = { class: "Paper__subject" }
const _hoisted_7 = { class: "Paper__lines" }
const _hoisted_8 = { class: "Paper__line-tools" }
const _hoisted_9 = {
  key: 0,
  class: "Paper__invoice-text irl"
}
const _hoisted_10 = {
  key: 1,
  class: "Paper__footer-image irl"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "irl" }

import Logo from "@/components/general/Logo.vue";
import DocumentInfo from "@/components/pages/document/parts/DocumentInfo.vue";
import { computed, PropType } from "vue";
import { Document } from "@/types";
import DocumentClientAddress from "@/components/pages/document/parts/DocumentClientAddress.vue";
import DocumentSubject from "@/components/pages/document/parts/DocumentSubject.vue";
import DocumentCompanyAddress from "@/components/pages/document/parts/DocumentCompanyAddress.vue";
import { useDocumentsStore } from "@/stores/documents";
import { useCompanyStore } from "@/stores/company";
import DocumentLegal from "@/components/pages/document/parts/DocumentLegal.vue";
import DocumentLines from "@/components/pages/document/parts/lines/DocumentLines.vue";
import DocumentLineTools from "@/components/pages/document/parts/DocumentLineTools.vue";
import DocumentTotal from "@/components/pages/document/parts/DocumentTotal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Paper',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    editable: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {

const props = __props;

const documentsStore = useDocumentsStore();
const companyStore = useCompanyStore();

const client = computed(() =>
    documentsStore.getClientForDocument(props.document)
);

const company = computed(() => companyStore.company);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "Paper",
    "data-concept": !__props.document.locked
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Logo, { size: 12 })
        ]),
        _createVNode(DocumentInfo, {
          document: __props.document,
          editable: __props.editable
        }, null, 8, ["document", "editable"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (client.value)
          ? (_openBlock(), _createBlock(DocumentClientAddress, {
              key: 0,
              document: __props.document,
              client: client.value,
              editable: __props.editable
            }, null, 8, ["document", "client", "editable"]))
          : _createCommentVNode("", true),
        (company.value && client.value)
          ? (_openBlock(), _createBlock(DocumentCompanyAddress, {
              key: 1,
              company: company.value,
              document: __props.document,
              client: client.value
            }, null, 8, ["company", "document", "client"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(DocumentSubject, {
          document: __props.document,
          editable: __props.editable
        }, null, 8, ["document", "editable"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(DocumentLines, {
          document: __props.document,
          lines: __props.document.lines,
          editable: __props.editable
        }, null, 8, ["document", "lines", "editable"]),
        _createElementVNode("div", _hoisted_8, [
          (__props.editable)
            ? (_openBlock(), _createBlock(DocumentLineTools, {
                key: 0,
                document: __props.document,
                lines: __props.document.lines
              }, null, 8, ["document", "lines"]))
            : _createCommentVNode("", true)
        ]),
        (client.value && !__props.document.hideTotal)
          ? (_openBlock(), _createBlock(DocumentTotal, {
              key: 0,
              document: __props.document,
              lines: __props.document.lines,
              client: client.value
            }, null, 8, ["document", "lines", "client"]))
          : _createCommentVNode("", true)
      ]),
      (company.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (__props.document.doctype === 'invoice')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (__props.document.english)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(company.value.invoiceTextEnglish), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(company.value.invoiceText), 1)
                      ], 64))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Op deze offerte zijn bijgeleverde Algemene Voorwaarden van toepassing ")
                ], 64))
          ]))
        : _createCommentVNode("", true),
      (company.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("img", {
              src: company.value.footerImageUrl
            }, null, 8, _hoisted_11)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        (company.value)
          ? (_openBlock(), _createBlock(DocumentLegal, {
              key: 0,
              company: company.value,
              document: __props.document
            }, null, 8, ["company", "document"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})